// extracted by mini-css-extract-plugin
export var darkMode = "_k-0";